const buttonContainer = document.querySelectorAll('.button-container-anoucement-bar');

buttonContainer.forEach(container => {
    const button = container.querySelector('.button-copy-pdp');
    const cupomOpen = container.querySelector('.copy-icon');
    const cupomCopied = container.querySelector('.check-icon');
    const textButton = container.querySelector('.button-text');

    button.addEventListener('click', () => {        
        
        const cupomText = container.dataset.cupomTextPdp;
        navigator.clipboard.writeText(cupomText);

        if (cupomCopied.classList.contains('hidden')) {
            cupomCopied.classList.remove('hidden');
            cupomOpen.classList.add('hidden');
            textButton.innerText = 'COPIADO!';
        }

        setTimeout(() => {
            cupomCopied.classList.add('hidden');
            cupomOpen.classList.remove('hidden');
            textButton.innerText = 'COPIAR';
        }, 2000);

}) });